import { GetHubCurrentOrdersResponse, GetHubPastOrdersData } from '@/types';
import { ListOption } from '@/components/list-item';
import { v4 as uuidv4 } from 'uuid';

export type HubOrder = GetHubCurrentOrdersResponse | GetHubPastOrdersData;
export type HubOrderOption = ListOption<{
  order: HubOrder;
}>;

export const toOrderOption = (order: HubOrder): HubOrderOption => {
  return {
    metadata: { order },
    title: order.restaurant_name,
    value: getStableId(order),
  };
};

export const getStableId = (order: HubOrder): string => {
  // pick whichever id exists and is truthy
  return (
    ('invoice_id' in order && order.invoice_id) ||
    ('order_id' in order && order.order_id) ||
    uuidv4()
  );
};

export const isCurrentOrder = (
  order: HubOrder,
): order is GetHubCurrentOrdersResponse => {
  return 'is_draft_order' in order;
};

export const isPastOrder = (order: HubOrder): order is GetHubPastOrdersData => {
  return 'order_date' in order && !('is_draft_order' in order);
};
